import React from 'react'
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";

const Page = ({children, hideFooter})  => {
    return (
        <>
            <Header />
            <>{children}</>
            { !hideFooter && <Footer /> }
        </>
    )
}
export default Page
